import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";
import { extendConfigWithXWingspanUserHeader } from "../../shared/utils/extendHeadersWithXWingspanUser";

export const resetPayeeRequirement = async (
  payeeId: string,
  requirementId: string,
  orgPayerId: string | undefined
): Promise<IRequirementResponse> => {
  const { data } = await servicePayments.post(
    `/payee/${payeeId}/requirement/${requirementId}/reset`,
    {},
    extendConfigWithXWingspanUserHeader({}, orgPayerId)
  );
  return data;
};
